import { render, staticRenderFns } from "./SfModal.vue?vue&type=template&id=26b71488&"
import script from "./SfModal.vue?vue&type=script&lang=js&"
export * from "./SfModal.vue?vue&type=script&lang=js&"
import style0 from "./SfModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports